// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hOJON{display:flex;flex-direction:column;gap:16px;width:100%}.OR9f5{display:flex;gap:8px;border-bottom:1px solid #e0e0e0}.fzNFM{display:flex;flex-direction:column;align-items:flex-start;background:none;border:none;padding:12px 16px;cursor:pointer;color:#555;border-bottom:2px solid transparent}.RoYsP{color:#111;border-bottom-color:#111;font-weight:600}.J8yma{font-size:12px;color:#777}.mRUmR{padding:8px 0}.KX_Fq{height:240px;background:#f5f5f5;border-radius:8px;animation:bB3uq 1.6s ease-in-out infinite}@keyframes bB3uq{0%,100%{opacity:1}50%{opacity:.6}}.FHze3{padding:16px;color:#b00020;background:#fdecec;border-radius:8px}.fQPtm{display:none}.Cho3L{display:flex;flex-direction:column;gap:8px}.rHXtX{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border:1px solid #e0e0e0;border-radius:8px;background:#fff}.rHXtX.WsxPY{border-color:#111}.DRib0{flex:1;display:flex;align-items:center;gap:10px;background:none;border:none;text-align:left;cursor:pointer;padding:0}.gIS5D{font-weight:600;text-transform:capitalize}.Nbc3P{color:#555}.PPEpg{color:#777;font-size:12px}.o3Q9z{margin-left:auto;padding:2px 8px;border-radius:10px;background:#111;color:#fff;font-size:12px}.aJHd2{position:relative}.fJP9p{background:none;border:none;cursor:pointer;padding:4px 8px;font-size:18px}.HxY1p{position:absolute;right:0;top:100%;background:#fff;border:1px solid #e0e0e0;border-radius:6px;padding:8px 12px;cursor:pointer;white-space:nowrap;z-index:1}.tPmfa{background:none;border:none;color:#1a73e8;cursor:pointer;padding:8px 0;text-align:left;font-size:14px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `hOJON`,
	"tabs": `OR9f5`,
	"tab": `fzNFM`,
	"tabActive": `RoYsP`,
	"feeLabel": `J8yma`,
	"tabContent": `mRUmR`,
	"loading": `KX_Fq`,
	"pulse": `bB3uq`,
	"error": `FHze3`,
	"testTrigger": `fQPtm`,
	"savedList": `Cho3L`,
	"savedRow": `rHXtX`,
	"savedRowSelected": `WsxPY`,
	"savedRowMain": `DRib0`,
	"savedRowLabel": `gIS5D`,
	"savedRowLast4": `Nbc3P`,
	"savedRowExpiry": `PPEpg`,
	"selectedBadge": `o3Q9z`,
	"savedRowMenu": `aJHd2`,
	"menuButton": `fJP9p`,
	"disconnectButton": `HxY1p`,
	"addAnotherButton": `tPmfa`
};
export default ___CSS_LOADER_EXPORT___;
